import { CustomSelect as Select } from 'src/components/common/select'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useGetTeacherLevels from 'src/hooks/common/useGetteacherLevels'

const SelectTeacherLevel = ({ multiple = false, value, onChange }) => {
  const { t } = useTranslation()
  const teacherLevelOptions = useGetTeacherLevels()

  return (
    <Select
      options={teacherLevelOptions}
      multiple={multiple}
      allowClear
      placeholder={t('page.class.label.rank')}
      value={value}
      onChange={onChange}
    />
  )
}
export default SelectTeacherLevel
